import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PromiseStatuses } from "../../../../lib/types";
import { CreateEventDTO, EventResponseDTO, EventsFiltersDTO } from "../../../calendar/dto";
import { NewEventsService } from "../../../calendar/service";

interface RecallState {
    operationType: 'save' | 'edit'
    errors: {
        create: {
            date: boolean
            time: boolean
            notification: boolean
            status: PromiseStatuses
        }
    }
}

const initialState: RecallState = {
    operationType: 'save',
    errors: {
        create: {
            date: false,
            time: false,
            notification: false,
            status: 'idle'
        }
    }
};

export const validateRecall = createAsyncThunk(
    "recalls/validateRecall",
    async (request: {
        date: Date | null
        time: Date | null
        notification: number
    }, thunkApi): Promise<void> => {
        let isValid = true;

        thunkApi.dispatch(setErrorsCreateDate(false));
        thunkApi.dispatch(setErrorsCreateTime(false));
        thunkApi.dispatch(setErrorsCreateNotification(false));
        thunkApi.dispatch(setErrorsCreateStatus("idle"));

        if (request.date === null) {
            thunkApi.dispatch(setErrorsCreateDate(true));
            isValid = false;
        }

        if (request.time === null) {
            thunkApi.dispatch(setErrorsCreateTime(true));
            isValid = false;
        }

        if (request.notification === undefined) {
            thunkApi.dispatch(setErrorsCreateNotification(true));
            isValid = false;
        }

        if (!isValid) {
            return Promise.reject();
        }

        return Promise.resolve();
    }
);

const recallSlice = createSlice({
    name: 'recalls',
    initialState,
    reducers: {
        setErrorsCreateDate: (state, action) => {
            state.errors.create.date = action.payload;
        },
        setErrorsCreateTime: (state, action) => {
            state.errors.create.time = action.payload;
        },
        setErrorsCreateNotification: (state, action) => {
            state.errors.create.notification = action.payload;
        },
        setErrorsCreateStatus: (state, action) => {
            state.errors.create.status = action.payload;
        },
        setOperationType: (state, action) => {
            state.operationType = action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(validateRecall.pending, (state) => {
                state.errors.create.status = "loading";
            })
            .addCase(validateRecall.fulfilled, (state) => {
                state.errors.create.status = "successfully";
            })
            .addCase(validateRecall.rejected, (state) => {
                state.errors.create.status = "failed";
            })
    },
});

export const {
    setErrorsCreateDate,
    setErrorsCreateTime,
    setErrorsCreateNotification,
    setErrorsCreateStatus,
    setOperationType,
} = recallSlice.actions;
export default recallSlice.reducer;
